import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-task-datepicker',
    templateUrl: './task-datepicker.component.html',
    styleUrls: ['./task-datepicker.component.scss'],
    standalone: false
})
export class TaskDatepickerComponent {
  constructor() { }
  @Input() form: UntypedFormGroup;
  @Input() dateFormat;
  @Input() locale;
  @Input() minEndDate;
  @Input() submittedForm;

  @Output() updateDateEnd = new EventEmitter();

}
